
export class PhaseToolbarModel {
  index: number; 
  code: string;
  description: string;
  visible: boolean = true;
  done: boolean = false;
  current: boolean = false;
  firstUndone: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/phases-toolbar.model.ts